module.exports = __webpack_public_path__ + "media/flags/pg-2ff7e7d2.svg";